import { checkStatusType } from "../const";
import { Image, Table } from "antd";
import { FoodRecognitionComponent } from "./FoodRecognitionComponent";
import summary from '../../images/identification-summary.png';
import identificationIcon from '../../images/identification-icon.png';

export default function FoodRecognitionResult({
    dataList,
    row,
    id,
}: any) {
    const removePTags = (html: string): string => {
        if (!html) return '';
        return html.replace(/<p>/g, '').replace(/<\/p>/g, '').replace(/\n/g, '<br/>');
    };

    const getExpandedData = () => {
        const foundItem: any = dataList?.find((item: any) => item?.checkRecordId === id);
        return foundItem;
    }

    const foodRecognitionFeatures: any = () => {
        const FoodCategorySection = ({ title, datas }: any) => {
            if (!datas || datas.length === 0) return null;
            return (
                <div>
                    <div className="title" style={{ marginTop: 30 }}>{title}</div>
                    <div className="box-container">
                        <div className="tongue-content-wrapper">
                            <div style={{ color: '#333333', fontSize: 15, fontWeight: 500, textAlign: 'center', letterSpacing: '1px', marginBottom: '18px' }}>
                                {datas?.food_list?.map((item: any) => item.food_name).join(' + ') || '未知'}
                            </div>
                            {datas?.food_list.map((item: any) => (
                                <div
                                    key={item.food_name}
                                    className="tongue-content"
                                    style={{ marginBottom: 20 }}
                                >
                                    <div style={{ color: '#94724B', fontSize: 16, fontWeight: 500, marginBottom: 10 }}>
                                        {item.food_name || '未知'}
                                    </div>
                                    <div style={{ color: '#666666', fontSize: 15, lineHeight: '24px', letterSpacing: '1px' }}>
                                        <span style={{ color: '#333333' }}>特点: </span>
                                        <span dangerouslySetInnerHTML={{ __html: removePTags(item.description) }}></span>
                                    </div>
                                </div>
                            ))}
                            <div className="tongue-content" >
                                <div style={{ color: '#94724B', fontSize: 16, fontWeight: 500, marginBottom: 10 }}>
                                    总体建议
                                </div>
                                <div style={{ color: '#333333', fontSize: 15, fontWeight: 500, lineHeight: '24px', letterSpacing: '1px' }}>
                                    <span dangerouslySetInnerHTML={{ __html: removePTags(datas.general_advice) }}></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        };

        const SpecialHighlight = ({ title, datas }: any) => {
            if (!datas || datas.length === 0) return null;
            return (
                <div>
                    <div className="title" style={{ marginTop: 30 }}>{title}</div>
                    <div className="box-container">
                        <div className="tongue-content-wrapper">
                            <div className="tongue-content">
                                <div style={{ color: '#333333', fontSize: 15, fontWeight: 500, textAlign: 'center', letterSpacing: '1px', marginBottom: '18px' }}>
                                    {datas.highlights_title}</div>
                                <div style={{ color: '#666666', fontSize: 15, lineHeight: '24px', letterSpacing: '1px' }}>
                                    <span dangerouslySetInnerHTML={{ __html: removePTags(datas.highlights) }}></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        };

        const Summary = ({ datas }: any) => {
            if (!datas) return null;
            return (
                <div>
                    <div style={{
                        marginTop: 20,
                        position: 'relative',
                        textAlign: 'center',
                        backgroundImage: `url(${summary})`,
                        backgroundSize: '100% 100%',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '20px 0'
                    }}>
                        <div style={{
                            fontWeight: 600,
                            fontSize: '18px',
                            lineHeight: '25px',
                            color: '#94724B',
                            textAlign: 'center',
                            maxWidth: '80%',
                            wordWrap: 'break-word',
                            wordBreak: 'break-word',
                            whiteSpace: 'normal',
                        }}>
                            {datas || '未知'}
                        </div>
                    </div>
                    <div style={{ marginTop: 20, position: 'relative', textAlign: 'center' }}>
                        <Image
                            src={identificationIcon}
                            preview={false}
                            style={{ width: '100%' }}
                        />
                    </div>
                </div>
            );
        };

        const ConsumptionSuggestions = ({ title, datas }: any) => {
            if (!datas || datas.length === 0) return null;
            return (
                <div>
                    <div className="title" style={{ marginTop: 30 }}>{title}</div>
                    <div className="box-container">
                        <div className="tongue-content-wrapper">
                            <div style={{ color: '#333333', fontSize: 15, fontWeight: 500, textAlign: 'center', letterSpacing: '1px', marginBottom: '18px' }}>
                                最近体质: {datas.constitution}</div>
                            <div className="tongue-content">
                                <div style={{ color: '#94724B', fontSize: 16, fontWeight: 500, marginBottom: 10 }}>宜食</div>
                                {datas.consumption_suggestions?.suitable.map((item: any) =>
                                    <div
                                        key={item.food_name}
                                        style={{
                                            color: '#666666',
                                            fontSize: 15,
                                            lineHeight: '24px',
                                            letterSpacing: '1px',
                                            marginBottom: 20
                                        }}>
                                        <span style={{ color: '#333333' }}>{item.food_name}: </span>
                                        <span dangerouslySetInnerHTML={{ __html: removePTags(item.reason) }}></span>
                                    </div>
                                )}
                                <div style={{ color: '#94724B', fontSize: 16, fontWeight: 500, marginBottom: 10 }}>慎食</div>
                                {datas.consumption_suggestions?.avoid.map((item: any, index: number, array: any[]) =>
                                    <div
                                        key={item.food_name}
                                        style={{
                                            color: '#666666',
                                            fontSize: 15,
                                            lineHeight: '24px',
                                            letterSpacing: '1px',
                                            marginBottom: index === array.length - 1 ? 0 : 20
                                        }}>
                                        <span style={{ color: '#333333' }}>{item.food_name}: </span>
                                        <span dangerouslySetInnerHTML={{ __html: removePTags(item.reason) }}></span>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            );
        };

        const DietaryRecommendations = ({ title, datas }: any) => {
            if (!datas || datas.length === 0) return null;
            return (
                <div>
                    <div className="title" style={{ marginTop: 30 }}>{title}</div>
                    <div className="box-container">
                        <div className="tongue-content-wrapper">
                            <div style={{ color: '#333333', fontSize: 15, fontWeight: 500, textAlign: 'center', letterSpacing: '1px', marginBottom: '18px' }}>
                                目标: {datas.recommendation_goal}</div>
                            {datas.recipes.map((item: any, index: number, array: any[]) =>
                                <div key={item.dish_name} className="tongue-content" style={{ marginBottom: index === array.length - 1 ? 0 : 20 }}>
                                    <div style={{ color: '#94724B', fontSize: 16, fontWeight: 500, marginBottom: 10 }}>
                                        {item.dish_name || '未知'}</div>
                                    <div style={{ color: '#666666', fontSize: 15, lineHeight: '24px', letterSpacing: '1px', marginBottom: 10 }}>
                                        <span style={{ color: '#333333' }}>做法: </span>
                                        <span dangerouslySetInnerHTML={{ __html: removePTags(item.preparation) }}></span>
                                    </div>
                                    <div style={{ color: '#666666', fontSize: 15, lineHeight: '24px', letterSpacing: '1px' }}>
                                        <span style={{ color: '#333333' }}>功效: </span>
                                        <span dangerouslySetInnerHTML={{ __html: removePTags(item.efficacy) }}></span>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            );
        };

        const NatureFlavorMeridianTropism = ({ title, datas }: any) => {
            if (!datas || datas.length === 0) return null;

            const columns: any[] = [
                {
                    title: "菜品",
                    dataIndex: "food_name",
                    align: "center",
                    search: false,
                    fixed: 'left',
                },
                {
                    title: "主要食材",
                    dataIndex: "main_ingredients",
                    align: "center",
                    search: false,
                },
                {
                    title: "性味归经",
                    dataIndex: "nature_flavor_meridian",
                    align: "center",
                    search: false,
                },
                {
                    title: "功效简述",
                    dataIndex: "efficacy",
                    align: "center",
                    search: false,
                },
            ];

            return (
                <div>
                    <div className="title" style={{ marginTop: 30 }}>{title}</div>
                    <Table
                        rowKey='food_name'
                        scroll={{ x: 400 }}
                        columns={columns}
                        dataSource={datas}
                        pagination={false}
                        style={{
                            borderRadius: '20px',
                            overflow: 'hidden',
                            border: '2px solid #DACCBB'
                        }}
                        className="food-recognition-table"
                        onHeaderRow={() => ({
                            style: {
                                backgroundColor: '#FAF5EF'
                            }
                        })}
                    />
                </div>
            );
        };

        return {
            FoodCategorySection,
            SpecialHighlight,
            Summary,
            ConsumptionSuggestions,
            DietaryRecommendations,
            NatureFlavorMeridianTropism,
        };
    };

    if (getExpandedData()?.foodsData?.results?.length === 0) {
        const expandedData = getExpandedData();
        if (!expandedData) {
            return <div style={{ display: "flex", justifyContent: "space-around" }}>
                检测结果不存在或已被删除
            </div>
        }
        return <>
            <div style={{ display: "flex", justifyContent: "space-around" }}>
                <div>检测状态：{checkStatusType[row?.status]?.text || row.status}</div>
                <div>检测图片：<Image width={25} height={50} src={expandedData?.imageUrl} /></div>
                <div>原因:{row.reason}</div>
            </div>
        </>
    }

    const { FoodCategorySection, SpecialHighlight, Summary, ConsumptionSuggestions,
        DietaryRecommendations, NatureFlavorMeridianTropism } = foodRecognitionFeatures();

    return (
        <div className="expandRow">
            <div style={{ width: '23%' }} >
                <FoodRecognitionComponent
                    data={getExpandedData()}
                    imageUrl={getExpandedData()?.generatePictureData?.qwenAnimationUrl}
                />
            </div>
            {
                getExpandedData()?.suggestData && <div style={{ width: '23%' }}>
                    <ConsumptionSuggestions title="食用建议" datas={getExpandedData()?.suggestData} />
                    <DietaryRecommendations title="饮食推荐" datas={getExpandedData()?.suggestData?.dietary_recommendations} />
                </div>
            }
            <div style={{ width: '23%' }}>
                <FoodCategorySection title="优质碳水" datas={getExpandedData()?.infoData?.carbs_food} />
                <FoodCategorySection title="高质量蛋白" datas={getExpandedData()?.infoData?.protein_food} />
                <FoodCategorySection title="膳食纤维" datas={getExpandedData()?.infoData?.fiber_food} />
            </div>
            <div style={{ width: '23%' }}>
                <SpecialHighlight title="特别出彩细节" datas={getExpandedData()?.excellentData?.chicken_soup_special_highlight} />
                <NatureFlavorMeridianTropism title="食物性味归经" datas={getExpandedData()?.propertyData?.nature_flavor_meridian_tropism} />
                <Summary datas={getExpandedData()?.excellentData?.chicken_soup_special_highlight?.soup_for_soul} />
            </div>
        </div>
    );
}